/* VOWHOUND: autoplay the Christmas Elf Booties gallery video only when selected.
 * The first product photo remains the lead image; all other products are unaffected.
 */
(() => {
  'use strict';
  const videoMediaSelector = '.product-media[data-media-id="70747855192433"]';

  function pauseBootVideo(gallery) {
    for (const container of gallery.querySelectorAll(videoMediaSelector)) {
      const deferred = container.querySelector('deferred-media');
      const video = deferred?.querySelector('video');
      if (video && !video.paused) video.pause();
      if (deferred && typeof deferred.pauseMedia === 'function') deferred.pauseMedia();
    }
  }

  function startBootVideo(slide) {
    const media = slide.querySelector(videoMediaSelector);
    if (!media) return;
    const deferred = media.querySelector('deferred-media');
    if (!deferred) return;

    // Horizon defers the actual video element until a customer presses Play.
    // Reveal it when the video slide becomes active, without user interaction.
    if (!deferred.hasAttribute('data-media-loaded')) {
      if (typeof deferred.showDeferredMedia === 'function') {
        deferred.showDeferredMedia();
      } else {
        return; // leave the original Play button if the theme changes
      }
    }
    const video = deferred.querySelector('video');
    if (!video) return;
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.loop = true;
    video.setAttribute('loop', '');
    const playback = video.play();
    if (playback && typeof playback.catch === 'function') {
      playback.catch(() => {
        // If a browser blocks playback, Horizon's Play control remains usable.
      });
    }
  }

  // Horizon emits this event for swipe, arrow, or thumbnail selection.
  // Delegate from document so selecting a variant (which replaces the gallery)
  // does not remove the behavior.
  document.addEventListener('slideshow:select', (event) => {
    const gallery = event.target?.closest?.('media-gallery');
    const slide = event.detail?.slide;
    if (!gallery || !slide || !gallery.classList.contains('media-gallery--carousel')) return;
    pauseBootVideo(gallery);
    if (!document.hidden) startBootVideo(slide);
  });

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) return;
    for (const gallery of document.querySelectorAll('main media-gallery')) {
      pauseBootVideo(gallery);
    }
  });
})();
